export default defineNuxtRouteMiddleware((to) => {
  const publicRoutes = ['/login', '/selectTenant', '/resetPassword', '/customers']

  if (publicRoutes.includes(to.path)) {
    return
  }

  const authStore = useAuthStore()
  const { hasPermission } = usePermissions()

  // ==========================
  // CUSTOMER SESSION
  // ==========================
  if (authStore.sessionType === 'customer') {

    if (!authStore.token) {
      authStore.logout()
      return navigateTo('/customers')
    }

    if (!to.path.startsWith('/portal')) {
      return navigateTo('/portal')
    }
  }
  // ==========================
  // INTERNAL SESSION
  // ==========================
  else {
    if (to.path.startsWith('/selectTenant') && !authStore.token) {
      authStore.logout()
      return navigateTo('/login')
    }

    if (!authStore.token || !authStore.selectedTenant || !authStore.user) {
      authStore.logout()
      return navigateTo('/login')
    }

    // Un usuario interno no entra al portal
    if (to.path.startsWith('/portal')) {
      return navigateTo('/')
    }
  }

  // ==========================
  // PERMISSIONS
  // ==========================
  const permissions = to.meta.permission

  if (!permissions) {
    return
  }
  const permissionList = Array.isArray(permissions)
    ? permissions
    : [permissions]

  if (!permissionList.some(permission => hasPermission(permission))) {
    return navigateTo('/403')
  }
})